<app-loading-indicator
  [isLoading]="isLoadingMyInstruction || isLoadingMyInstructionConfirmation"
></app-loading-indicator>

@if (myInstruction) {
  <div class="flex h-full flex-grow flex-col">
    <div class="card bg-base-100">
      <div class="card-body">
        <p class="text-2xl md:text-3xl">{{ myInstruction.title }}</p>
        <div class="flex flex-col text-sm md:text-base">
          <div class="text-neutral-600">
            {{ "instruction.instruction-detail.created" | translate }}
            {{
              myInstruction.modified
                | date: ("common.dateTimeFormat" | translate)
            }}
          </div>
          <div
            [class.text-neutral-600]="deadlineStatus == 'none'"
            [class.text-warning]="deadlineStatus == 'soon'"
            [class.text-error]="deadlineStatus == 'overdue'"
            [class.font-bold]="deadlineStatus != 'none'"
          >
            @if (myInstructionConfirmation?.deadline; as deadline) {
              @if (
                myInstructionConfirmation &&
                myInstructionConfirmation.status != "submitted"
              ) {
                {{ "instruction.instruction-detail.deadline" | translate }}
                {{ deadline | date: ("common.dateTimeFormat" | translate) }}
              }
            }
          </div>
        </div>
      </div>
      <app-chapters (chapterSelected)="chapterSelected($event)"></app-chapters>
    </div>

    <div class="card bg-base-100 my-4 flex flex-grow">
      <app-chapter-details class="flex-grow"></app-chapter-details>
    </div>
  </div>
}
